<!-- 短信接口管理 -->
<template>
  <div class="fuzzy-matching-box">
    <div class="fuzzy-matching-top">
        <el-button type="primary" size="medium" class="query-button" @click="entrylogClick">新增设置</el-button>
    </div>
    <div class="fuzzy-matching-bottom">
      <el-row class="list">
         <el-table
         :header-cell-style="{background:'#F2F2F2',color:'#000',}"
          ref="multipleTable"
          :data="tableData"
          tooltip-effect="dark"
          style="width: 100%"
          @selection-change="handleSelectionChange">
          <el-table-column
            prop="username"
            label="型号"
            >
          </el-table-column>
          <el-table-column
            prop="email"
            label="类型"
            >
          </el-table-column>
          <el-table-column
          label='操作'>
          <template #default="scope">
              <el-button size="medium" type="primary" @click="deleteClick(scope.row)" class="shanchu">修改</el-button>
              <el-button size="medium" type="danger" @click="deleteClick(scope.row)" class="shanchu">删除</el-button>
           </template>
          </el-table-column>
        </el-table>
        <div class="block-fenye" >
          <el-pagination
              :small="small"
              :disabled="disabled"
              :background="background"
              layout="prev, pager, next, jumper"
              :total="1000"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
            />
        </div>
      </el-row>

    </div>
  </div>
</template>

<script>
export default {
  components: {

  },
  data() {
      return {
        Dform:{
          username:''
        },
        tableData: [ 
           {
            username: 123,
            email: 'https:6546'
           }
        ]
      };
  },
  created() {

  },
  mounted() {

  },
  methods: {

  },
};
</script>

<style scoped lang="scss">
  .fuzzy-matching-box {
    padding-top: 20px;
    width: 100%;
    height:  92%;
    background-color: #fff;
    border-radius: 8px;
    .title-top {
        padding: 20px 20px;
    }
        .query-button{
          margin-left: 20px;
          }
   
  }
  .fuzzy-matching-bottom {
    height: calc(100% - 170px);
    overflow: auto;
    position: relative;
    padding: 0px 20px;
    padding-top: 10px;
    margin-top: 15px;
    background-color: #fff;
    border-radius: 8px;
    
    .top-first-line {
      height: 45px;
      line-height: 45px;
        /deep/ .tip-button {
          padding: 14px 14px;
          margin: 0px 3px;
        }
      .import-export-button {
        position: absolute;
        right: 20px;
        /deep/ .el-button--small {
          padding: 16px 24px;
          border: 1px solid #569CFF;
          color: #569CFF;
          
        }
      
      }
      // 
    }
    .list {
      position: relative;
      // margin-top: 10px;
      padding-bottom: 50px;
     .fenye {
      // float: right;
      text-align: center;
     }
      /deep/ {
        .el-table--small .cell {
          text-align: center;

        }
        .el-table td.el-table__cell, .el-table th.el-table__cell.is-leaf {
          border: 0px;
        }
        .el-table tr {
          height: 40px;
          cursor: pointer;
          user-select: none;
          font-size: 14px;
        }
      }
      .block-fenye {
        // float: right;
        position: absolute;
        bottom: 0px;
        left: 50%;
        transform: translate(-50%,0);
        
      }
    }
  }

</style>
